import { Injectable } from '@angular/core';
import { AppConfigService } from '@com-delta-idp/mnx-utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IDP_APPS } from '../../constants/urls.constants';
import { FeatureFlags } from '../../models/states/feature-flags-state.interfaces';
import * as fromFeatureFlagsActions from '../actions/feature-flags.actions';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsEffects {
  storeFeatureFlagsValues$ = createEffect(
    (): Observable<Action> =>
      this.featureFlagActions$.pipe(
        ofType(fromFeatureFlagsActions.StoreFeatureFlagsValues),
        switchMap(() => {
          const bookWidgetConfig = this.appConfigService.getConfig(
            IDP_APPS.BOOK_WIDGET
          );
          const featureFlags =
            (bookWidgetConfig['featureFlags'] as FeatureFlags) || null;
          return of(
            fromFeatureFlagsActions.StoreFeatureFlagsValuesSuccess({
              featureFlags
            })
          );
        })
      )
  );

  constructor(
    private featureFlagActions$: Actions,
    private appConfigService: AppConfigService
  ) {}
}
